import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useEffect, useRef, useState } from 'react';
import { insertArray } from '../helpers/insertArray';
import { setAnimationFrameTimeout } from '../helpers/setAnimationFrameTimeout';
export function useListTransition(list, timeout) {
    const keyRef = useRef(0);
    // change list to our list form with extra information.
    const initialList = list.map((item, key) => ({
        item,
        key: keyRef.current,
        stage: 'enter',
    }));
    const [listState, setListState] = useState(initialList);
    useEffect(function handleListChange() {
        const newItemsWithIndex = [];
        list.forEach((item, index) => {
            if (listState.every((itemState) => itemState.item !== item)) {
                newItemsWithIndex.push({ item, index });
            }
        });
        // 1 add new items into list state
        if (newItemsWithIndex.length > 0) {
            keyRef.current++;
            setListState((prevListState) => newItemsWithIndex.reduce((prev, { item, index }, i) => insertArray(prev, index, {
                item,
                key: keyRef.current,
                stage: 'from',
            }), prevListState));
        }
        // 2 enter those new items immediatly
        if (newItemsWithIndex.length === 0 &&
            listState.some((item) => item.stage === 'from')) {
            setAnimationFrameTimeout(() => {
                setListState((prev) => prev.map((item) => (Object.assign(Object.assign({}, item), { stage: item.stage === 'from' ? 'enter' : item.stage }))));
            });
        }
        // 3 leave items from list state
        const subtractItemStates = listState.filter((itemState) => !list.includes(itemState.item) && itemState.stage !== 'leave');
        const subtractItems = subtractItemStates.map((item) => item.item);
        if (newItemsWithIndex.length === 0 && subtractItemStates.length > 0) {
            setListState((prev) => prev.map((itemState) => subtractItemStates.includes(itemState)
                ? Object.assign(Object.assign({}, itemState), { stage: 'leave' }) : itemState));
            setAnimationFrameTimeout(() => {
                setListState((prev) => prev.filter((item) => !subtractItems.includes(item.item)));
            }, timeout);
        }
    }, [list, listState, timeout]);
    function transition(renderCallback) {
        return listState.map((item) => (_jsx(Fragment, { children: renderCallback(item.item, item.stage) }, item.key)));
    }
    return transition;
}
